module.exports = __webpack_public_path__ + "static/media/old.93a31087.jpeg";